import React from 'react';

interface Props {
  width?: number;
  height?: number;
  className?: string;
  onClick?: () => void;
}

export function IconShare(props: Props) {
  const { width = 48, height = 48, className = '', onClick } = props;

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <rect x="0.5" y="0.5" width={width - 1} height={height - 1} rx="5.5" fill="white" />
      <rect x="0.5" y="0.5" width={width - 1} height={height - 1} rx="5.5" stroke="#f97316" />
      <path
        d="M20.6312 22.4344C20.0566 21.2874 18.8702 20.5 17.5 20.5C15.567 20.5 14 22.067 14 24C14 25.933 15.567 27.5 17.5 27.5C18.8702 27.5 20.0566 26.7126 20.6312 25.5656M20.6312 22.4344C20.8672 22.9055 21 23.4372 21 24C21 24.5628 20.8672 25.0945 20.6312 25.5656M20.6312 22.4344L27.3688 19.0656M20.6312 25.5656L27.3688 28.9344M27.3688 19.0656C27.9434 20.2126 29.1298 21 30.5 21C32.433 21 34 19.433 34 17.5C34 15.567 32.433 14 30.5 14C28.567 14 27 15.567 27 17.5C27 18.0628 27.1328 18.5945 27.3688 19.0656ZM27.3688 28.9344C27.1328 29.4055 27 29.9372 27 30.5C27 32.433 28.567 34 30.5 34C32.433 34 34 32.433 34 30.5C34 28.567 32.433 27 30.5 27C29.1298 27 27.9434 27.7874 27.3688 28.9344Z"
        stroke="#f97316"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </svg>
  );
}
